import React from 'react'

import SelectInput from '../../components/form/SelectInput'
import { useI18N } from '../../../libraries/i18n/hook'
import { ContractType } from '../../../api/job-offers/types'

type Props = {
  onChange: (values: { contractType: ContractType[] }) => void,
  values?: string[]
}
const ContractTypeSelectBox: React.FC<Props> = ({ onChange, values }) => {
  const { t } = useI18N()

  const handleChange = (contractType: string[]) => {
    onChange({ contractType: contractType as ContractType[] })
  }

  const options = [
    { label: t('jobs.internship'), value: ContractType.INTERNSHIP },
    { label: t('jobs.unlimited'), value: ContractType.FULL_TIME },
  ]

  return (
    options && (
      <SelectInput
        isDisabled={options?.length === 0}
        value={options?.filter(contractType => values?.includes(contractType.value.toString()))}
        name='contractType'
        label={t('jobs.contract.type')}
        onChange={handleChange}
        options={options}
        autoMinWidth
      />
    )
  )
}

export default ContractTypeSelectBox
